const getHandoffRow = (navigationState) =>
  [navigationState?.extractToolData, navigationState?.submissionData].find(
    (candidate) => candidate?.submissionIdentifier,
  );

const encodePathSegment = (value) => encodeURIComponent(String(value));

export const buildClassicQaToolPath = (navigationState) => {
  const row = getHandoffRow(navigationState);
  if (!row?.submissionIdentifier) {
    return "/user/submissions";
  }

  const path = [
    "/user/submissions/qatool",
    encodePathSegment(row.submissionIdentifier),
  ];

  if (row.templateName && row.documentName) {
    path.push(encodePathSegment(row.templateName));
    path.push(encodePathSegment(row.documentName));
  }

  return path.join("/");
};
